import React from 'react';

export type AskAiVideo = {
  title: string;
  url: string;
  thumbnail: string;
  format?: string;
  videoId?: string;
};

export function stripYoutubeUrlsFromAnswer(text: string): string {
  return String(text || '')
    .replace(/\[([^\]]+)\]\(https?:\/\/(?:www\.)?youtube\.com\/[^)]+\)/gi, '')
    .replace(/https?:\/\/(?:www\.)?youtube\.com\/[^\s)<>]+/gi, '')
    .replace(/^\s*(Desktop|Mobile):\s*$/gim, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

const AskAiVideoGallery: React.FC<{ videos: AskAiVideo[] }> = ({ videos }) => {
  if (!videos.length) return null;
  return (
    <ul className="aac-video-grid">
      {videos.map((video) => (
        <li key={video.url}>
          <a
            className="aac-video-card"
            href={video.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="aac-video-thumb">
              <img
                src={video.thumbnail}
                alt=""
                loading="lazy"
                onError={(event) => {
                  const image = event.currentTarget;
                  if (image.src.includes('hqdefault')) {
                    image.src = image.src.replace('hqdefault', 'mqdefault');
                  }
                }}
              />
              {video.format && (
                <span className="aac-video-format">{video.format}</span>
              )}
              <span className="aac-video-play" aria-hidden="true">
                <svg viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M10 8.5v7l6-3.5-6-3.5Z" />
                </svg>
              </span>
            </span>
            <span className="aac-video-title">{video.title}</span>
          </a>
        </li>
      ))}
    </ul>
  );
};

export default AskAiVideoGallery;
